module.exports = __webpack_public_path__ + "static/img/oca.66b4c7e2.svg";